import { $, $$ } from './utils'

export const loadMoreCasinos = (button) => {
  const table = $(`[data-listing-id="${button.dataset.limitId}"]`)
  if (!table) return

  let loadEachTime = button.dataset.count
  if (!loadEachTime || loadEachTime == -1) loadEachTime = 100 // eslint-disable-line

  const itemsNotDisplayed = $$('li[data-loaded="false"]', table)

  if (itemsNotDisplayed.length > loadEachTime) {
    Array.from(itemsNotDisplayed)
      .slice(0, loadEachTime)
      .forEach((li) => {
        li.dataset.loaded = 'true'
      })
  } else {
    itemsNotDisplayed.forEach((li) => {
      li.dataset.loaded = 'true'
    })
    button.parentNode.removeChild(button)
  }

  const wrapper = $(`[data-id="${button.dataset.limitId}"]`)
  if (wrapper) wrapper.removeAttribute('data-limit')
}
